import { React } from '@gravityforms/libraries';
import { useCache } from '../hooks/use-cache';

const { createContext, useContext } = React;

const CacheContext = createContext( null );

/**
 * @function useCacheContext
 * @description Uses the cache context to access the cache value.
 *
 * @since 4.0.5
 *
 * @return {object} The cache and cache functions.
 */
export const useCacheContext = () => useContext( CacheContext );

/**
 * @module CacheProvider
 * @description The cache provider component.
 *
 * @since 4.0.5
 *
 * @param {object}      props              The props for the component.
 * @param {JSX.Element} props.children     The children to render.
 * @param {object}      props.initialState The initial state of the cache.
 *
 * @return {JSX.Element} The cache provider.
 */
export const CacheProvider = ( { children, initialState } ) => {
	const value = useCache( initialState );
	return (
		<CacheContext.Provider value={ value }>
			{ children }
		</CacheContext.Provider>
	);
};
